// -------------- BANK Page --------------
export const BANK_FIELD_ERROR       = 'BANK_FIELD_ERROR';
export const BANK_FIELD_RESET_ERROR = 'BANK_FIELD_RESET_ERROR';
export const BANK_GET_ITEM          = 'BANK_GET_ITEM';
export const BANK_SET_ITEM          = 'BANK_SET_ITEM';
export const BANK_SET_ALL           = 'BANK_SET_ALL';
export const BANK_ADD_ITEM          = 'BANK_ADD_ITEM';

// -------------- FINANCE Page --------------
export const FINANCE_FIELD_ERROR       = 'FINANCE_FIELD_ERROR';
export const FINANCE_FIELD_RESET_ERROR = 'FINANCE_FIELD_RESET_ERROR';
export const FINANCE_GET_ITEM          = 'FINANCE_GET_ITEM';
export const FINANCE_SET_ITEM          = 'FINANCE_SET_ITEM';
export const FINANCE_SET_ALL           = 'FINANCE_SET_ALL';
export const FINANCE_ADD_ITEM          = 'FINANCE_ADD_ITEM';




// --------- FINANCE Page ---------
export function financeFieldError(field, fieldData = {}) {
    return { type: FINANCE_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function financeFieldResetError(field, fieldData = {}) {
    return { type: FINANCE_FIELD_RESET_ERROR }
}
export function financeSetItem(targetItem) {
    return { type: FINANCE_SET_ITEM, data: targetItem }
}
export function financeGetItem(targetItem) {
    return { type: FINANCE_GET_ITEM, data: targetItem }
}
export function financeAddItem(addItem) {
    return { type: FINANCE_ADD_ITEM, data: addItem }
}
export function financeSetList(allFINANCE) {
    return { type: FINANCE_SET_ALL, data: allFINANCE }
}
// --------- BANK Page ---------
export function bankFieldError(field, fieldData = {}) {
    return { type: BANK_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function bankFieldResetError(field, fieldData = {}) {
    return { type: BANK_FIELD_RESET_ERROR }
}
export function bankSetItem(targetItem) {
    return { type: BANK_SET_ITEM, data: targetItem }
}
export function bankGetItem(targetItem) {
    return { type: BANK_GET_ITEM, data: targetItem }
}
export function bankAddItem(addItem) {
    return { type: BANK_ADD_ITEM, data: addItem }
}
export function bankSetList(allBANK) {
    return { type: BANK_SET_ALL, data: allBANK }
}
